import { IncludeType } from '../../../common';
import { FamilyGroup } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getAttributesByGroups = async (
  productIds: string[],
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<FamilyGroup[]> => {
  const url = `/group/attributes?ids=${productIds.join('|')}&include=${encodeURIComponent(includeType)}&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<FamilyGroup[]>(url);
  return response.data;
};
